/** Defines all options for the OrbitCadEditorTool. */
export interface OrbitToolOptions {
  enableRotate: boolean;
  enableZoom: boolean;
  autoRotate: boolean;
  autoRotateSpeed: number;
}
